import React from 'react'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'

const ReferenceValueNotFound = () => (
  <section>
    <header>
      <PageTitle>
        Reference value not found!
      </PageTitle>
    </header>
    <br/>
    <BackButton/>
  </section>
)

export default ReferenceValueNotFound



// WEBPACK FOOTER //
// ./src/components/ReferenceValues/ReferenceValueNotFound.jsx